import React from 'react';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionItemDetailInnerTab as ActionItemDetailInnerTab } from 'ui/views/widgets/actionItemDetailInnerTab';
 *
 * // render
 * <ActionItemDetailInnerTab propName='propValue'/>
 */
export const actionItemDetailInnerTabSuccess = ( props ) => {
    return (
        <div className='ui-action-item-detail-inner-tab'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
                onTabActionClick= { props.onViewActionClick }
            />
        </div>
    );
};

// set display name
actionItemDetailInnerTabSuccess.displayName = 'actionItemDetailInnerTabSuccess';

// set default props
actionItemDetailInnerTabSuccess.defaultProps = {};

// prop types
actionItemDetailInnerTabSuccess.propTypes = {};

// Preloader view
export const actionItemDetailInnerTabPreloader = () => {
    return (
        <div className='ui-action-item-detail-inner-tab-preloader'>
           {/* <div className='ui-action-item-detail-inner-tab-preloader__pagination-spinner'>
                        <Spinner />
                    </div> */}
        </div>
    );
};

// set display name
actionItemDetailInnerTabPreloader.displayName = 'actionItemDetailInnerTabPreloader';

// set default props
actionItemDetailInnerTabPreloader.defaultProps = {};

// prop types
actionItemDetailInnerTabPreloader.propTypes = {};

export const actionItemDetailInnerTab = withNetworkState( actionItemDetailInnerTabPreloader, actionItemDetailInnerTabSuccess );

